const GRAPHQL_ENDPOINT = '/graphql/'

const TOKEN_KEY = 'jwt-auth-token'
const USER_KEY = 'auth-user'
const PATH_BEFORE_AUTH_KEY = 'path-before-auth'

const BOARDS_PER_PAGE = process.env.REACT_APP_BOARDS_PER_PAGE || 20
const QUESTIONS_PER_PAGE = process.env.REACT_APP_QUESTIONS_PER_PAGE || 20
const COMMENTS_PER_PAGE = process.env.REACT_APP_COMMENTS_PER_PAGE || 20

const SEGMENT_KEY = process.env.REACT_APP_SEGMENT_KEY
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const JS_SENTRY_DSN = process.env.REACT_APP_JS_SENTRY_DSN
const CHARGEBEE_SITE = process.env.REACT_APP_CHARGEBEE_SITE

export {
  GRAPHQL_ENDPOINT,
  TOKEN_KEY,
  USER_KEY,
  PATH_BEFORE_AUTH_KEY,
  BOARDS_PER_PAGE,
  QUESTIONS_PER_PAGE,
  COMMENTS_PER_PAGE,
  SEGMENT_KEY,
  SENTRY_DSN,
  JS_SENTRY_DSN,
  CHARGEBEE_SITE,
}



// WEBPACK FOOTER //
// ./src/config.js